import "./style.scss";
import $ from "jquery";

$(document).ready(function () {
    $('.block-toggle__change').click(function () {
        if (!$(this).hasClass("active")) {
            var current = $(this);
            $('.block-toggle__change').removeClass("active");
            $('.block-toggle__change').each(function(){
                var razred = $(this).data("razred");
                $('.'+razred).hide();
            });

            current.addClass("active");
            $('.' + current.data("razred")).show();
            if (current.data("smer") === "right") {
                $(".block-toggle .switch").addClass("right");
            } else {
                $(".block-toggle .switch").removeClass("right");
            }
        }
    });
    $(".block-toggle__change:first-child").trigger('click');

    $('.toggle-button').click(function () {
        var classList = $(this).attr("class");
        // Creating class array by splitting class list string
        var classArr = classList.split(/\s+/);
        $.each(classArr, function(index, value){
            if(value.startsWith("toggle-button-class")) {
                var razred = value.replace("toggle-button-class__", "");
                $('[data-razred="'+razred+'"]').trigger('click');
            }
        });
    });
});